export default __webpack_public_path__ + "static/media/002.831fd784.jpg";